module.exports = __webpack_public_path__ + "img/support.b7ff7157.svg";